/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/frame_action': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="16" cy="16" r="12"/><path pid="1" d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14c7.721 0 14-6.28 14-14S23.721 2 16 2z"/>'
  }
})
